const DEFAULT_SALARY_PERIODICITY_OPTION = { value: 'annual', text: 'Annual gross' };

const SALARY_PERIODICITY_OPTIONS = [
  DEFAULT_SALARY_PERIODICITY_OPTION,
  { value: 'monthly', text: 'Monthly gross' },
  { value: 'daily', text: 'Daily gross' },
  { value: 'hourly', text: 'Hourly gross' }
];

const DEFAULT_CURRENCY = 'US Dollar';

const STAGE_OPTIONS = [
  {
    value: 'Current',
    tooltip: 'Job opportunities actively seeking to fill positions now',
  },
  {
    value: 'Talent pool',
    tooltip:
      'The organization is building a talent pool to develop a ' +
      'go-to experts or pre-qualify candidates for future roles',
  },
  {
    value: 'Proposal',
    tooltip:
      'This organization is responding to a call for ' +
      'proposals, and offering a role subject to project award',
  },
];

const EXCLUSIVE_JOB_TYPE_ID = 2;
const NON_EXCLUSIVE_JOB_TYPE_ID = 1;

export {
  SALARY_PERIODICITY_OPTIONS,
  DEFAULT_SALARY_PERIODICITY_OPTION,
  DEFAULT_CURRENCY,
  STAGE_OPTIONS,
  EXCLUSIVE_JOB_TYPE_ID,
  NON_EXCLUSIVE_JOB_TYPE_ID,
};
